const webSocketUrl = process.env.REACT_APP_WEBSOCKET_URL;


export default webSocketUrl;
